import { render, staticRenderFns } from "./DesignSurface.vue?vue&type=template&id=68b4229a&"
import script from "./DesignSurface.vue?vue&type=script&lang=js&"
export * from "./DesignSurface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports